<template>
  <div class="testresults">
    <div class="testresults-box">
      <div class="exam-results-top">
        <van-nav-bar title="练习统计" left-arrow @click-left="
            $router.push({
                path: '/testDetail',
                query: {
                    courseId: $route.query.courseId,
                    trainId: $route.query.trainId,
                    businessId: $route.query.businessId,
                    businessType: $route.query.businessType,
                    taskType: $route.query.taskType,
                    backType: $route.query.backType,
                    practiceId: $route.query.practiceId,
                    backPath: $route.query.backPath,
                    goodsId:$route.query.goodsId,
                    goodsKind:$route.query.goodsKind,
                }
            })
        " />
      </div>
      <div class="exam-results-bgbox">
          <div class="exam-results-bg">
              <div class="exam-results-content1 exam-results-content">
                  <!--交卷完成列表-->
                  <div class="exam-results-circle">
                      <gauge :rate="+resultsobj.rightRate" :strokeColor="strokeColor">
                          <template v-slot:txt>
                              <p :class="+resultsobj.rightRate >= 50 ? 'passcolor' : 'nopasscolor'" class="exam-results-porgress">{{resultsobj.rightRate}}<span>%</span></p>
                              <p class='exam-num-tips1'>
                                  <span>正确率</span>
                              </p>
                          </template>
                      </gauge>
                  </div>
                  <div class="exam-results-title">
                      <p class="title">
                          {{resultsobj.practiceName}}
                      </p>
                  </div>
                  <div class="exam-results-ulbox">
                      <ul>
                          <li>
                              <p class="exam-results-correct">{{resultsobj.rightCount}}</p>
                              <span>答对(道)</span>
                          </li>
                          <li>
                              <p class="exam-results-error">{{resultsobj.errorCount}}</p>
                              <span>答错(道)</span>
                          </li>
                          <li>
                              <p>{{resultsobj.emptyCount}}</p>
                              <span>未答(道)</span>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
      <!-- 答题卡 -->
      <div class="testsheet">
          <h2>答题卡<span>/共{{resultsobj.totalCount}}题</span></h2>
          <p v-if="oneList.length>0" class="sheettype">单选题<span>(共{{oneList.length}}道)</span></p>
          <ul class="sheetlist">
              <li 
                v-for="(item, index) in oneList" :key="index" 
                class="sheetItem"
                :class="setColor(item)">{{item.index+1}}</li>
          </ul>
          <p v-if="moreList.length>0" class="sheettype">多选题<span>(共{{moreList.length}}道)</span></p>
          <ul class="sheetlist">
              <li 
                v-for="(item, index) in moreList" :key="index" 
                class="sheetItem"
                :class="setColor(item)">{{item.index+1}}</li>
          </ul>
          <p v-if="judgeList.length>0" class="sheettype">判断题<span>(共{{judgeList.length}}道)</span></p>
          <ul class="sheetlist">
              <li 
                v-for="(item, index) in judgeList" :key="index" 
                class="sheetItem"
                :class="setColor(item)">{{item.index+1}}</li>
          </ul>
      </div>
      <div class="exam-results-fotter">
          <div class="test-footer-btn"> 
              <button class="checkmistakes" @click="chackTest">查看练习</button>
                <button class="continustest" @click="againTest">重新练习</button>
          </div>
      </div>
    </div>
</div>
</template>

<script>
    import gauge from '../../exam/page/gauge.vue'
    export default {
        name: "testResultsTrain",
        components: {
            gauge,
        },
        data() {
            return {
                userPracticeId: null,
                iserror: false,
                resultsobj: {},
                strokeColor: '',
                questionsList: [],
                oneList: [],
                moreList: [],
                judgeList: [],
            };
        },
        created() {
            this.userPracticeId = this.$route.query.id
            this.findUserPaperInfo();
        },
        mounted() {
            if (window.history && window.history.pushState) {
                // 往历史记录里面添加一条新的当前页面的url
                history.pushState(null, null, document.URL);
                // 给 popstate 绑定一个方法 监听页面刷新
                window.addEventListener('popstate', this.backChange, false);//false阻止默认事件
            }
        },
        destroyed(){
            window.removeEventListener('popstate', this.backChange, false);//false阻止默认事件
        },
        methods: {
            chackTest() {
                this.$router.push({
                    path: '/testTrain',
                    query: {
                        userPracticeId: this.userPracticeId,
                        trainId: this.$route.query.trainId,
                        taskType: this.$route.query.taskType,
                        backType: this.$route.query.backType,
                        practiceId: this.$route.query.practiceId,
                        businessId: this.$route.query.businessId,
                        businessType: this.$route.query.businessType,
                    }
                })
            },
            setColor(item) {
                if(item.result === 1 && item.reply) {
                    return 'rightitem';
                } else if(item.result === 0  && item.reply){
                    return 'erroritem';
                } 
                if(!item.reply){
                    return 'itemborder';
                }
            },
            // 试卷详情回显
            async findUserPaperInfo() {
                const { data } = await this.$api.coursetest.findUserPaperInfo({userPracticeId: this.userPracticeId})
                this.resultsobj = data;
                this.resultsobj.rightRate = this.resultsobj.rightRate.split('.')[0]
                this.strokeColor = +this.resultsobj.rightRate >=50 ? '#415FF6' : '#FFA132'
                this.questionsList = data.examQuestionInfos;
                this.questionsList.forEach((item, index) => {
                    this.$set(item, 'index', index)
                    if(item.type === 1){
                        this.oneList.push(item)
                    } else if(item.type === 2){
                        this.moreList.push(item)
                    } else if(item.type === 3) {
                        this.judgeList.push(item)
                    }
                })
            },
            againTest(){
                if(!this.resultsobj.errorsCount && this.resultsobj.practiceModel === 4){
                    this.$toast('暂无错题')
                    return false;
                } else if(!this.resultsobj.markCount && this.resultsobj.practiceModel === 3){
                    this.$toast('暂无标记试题')
                    return false;
                }
                let params = {
                    businessId: this.$route.query.businessId,
                    businessType: this.$route.query.businessType,
                    practiceModel: this.resultsobj.practiceModel,
                    practiceId: this.$route.query.practiceId
                };
                this.$api.exam.userPracticejoinExam({ params }).then(({ data }) => {
                    this.$router.push({
                        path: "/testTrain",
                        query: {
                            practiceId: this.$route.query.practiceId,
                            userPracticeId:data,
                            backType:this.$route.query.backType,
                            trainId:this.$route.query.trainId,
                            courseId:this.$route.query.courseId,
                            taskType:this.$route.query.taskType,
                            businessId: this.$route.query.businessId,
                            businessType: this.$route.query.businessType,
                            lastTopic: 0,
                        }
                    })
                });
            },
            backChange(){
                this.$router.push({
                    path: '/testDetail',
                    query: {
                        courseId: this.$route.query.courseId,
                        trainId: this.$route.query.trainId,
                        businessId: this.$route.query.businessId,
                        businessType: this.$route.query.businessType,
                        taskType: this.$route.query.taskType,
                        backType: this.$route.query.backType,
                        practiceId: this.$route.query.practiceId
                    }
                })
            },
        },

    }
</script>
<style>
    .testresults-box .van-nav-bar {
        background: #426EF7;
    }

    .testresults-box .van-nav-bar__title {
        color: #fff !important;
    }

    .testresults-box .van-nav-bar .van-icon {
        color: #fff !important;
    }

    .testresults-box .van-hairline--bottom::after {
        border-bottom-width: 0px;
    }
</style>
<style lang='less' scoped>
@import '../asset/css/testresults.less';
</style>